module.exports = __webpack_public_path__ + "img/header-nav-below-cjdr.d5987fa4.png";